// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"73bb8e1d","952":"1b05518c"}[chunkId] + ".chunk.js";
};